import { Component, inject } from '@angular/core'
import { Principal, PrincipalService } from '@elderbyte/ngx-auth'
import { Observable } from 'rxjs'
import { Router } from '@angular/router'
import { ElderShellService, ElderSinglePaneWrapperComponent } from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { AsyncPipe } from '@angular/common'
import { MatButton } from '@angular/material/button'
import { MatIcon } from '@angular/material/icon'
import {
  MatCard,
  MatCardAvatar,
  MatCardContent,
  MatCardHeader,
  MatCardSubtitle,
  MatCardTitle,
} from '@angular/material/card'

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  imports: [
    MatCard,
    MatCardHeader,
    MatCardAvatar,
    MatIcon,
    MatCardTitle,
    MatCardSubtitle,
    MatCardContent,
    MatButton,
    AsyncPipe,
    ElderTranslatePipe,
    ElderSinglePaneWrapperComponent,
  ],
})
export class DashboardComponent {
  private router = inject(Router)
  private shellService = inject(ElderShellService)
  principal$: Observable<Principal>

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const principalService = inject(PrincipalService)
    this.principal$ = principalService.principalObservable
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public openSettings(event: Event): void {
    void this.router.navigate(['app/settings'])
  }

  public openNav(event: Event): void {
    this.shellService.toggleSidenav()
  }
}
